
<span class="badgeContainer">


    <div class="badgeContent">
        <div class="row" >
            <div class="col-md-12 mt-2">
                <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                    <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                        <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                        {{ alert.msg }}
                    </div>
                </div>
            </div>
        </div>
    <div class="separateBadges" *ngFor="let badge of badgeList">
        <input #imageUploader type="file" hidden name="avatar" (click)="imageUploader.value = null" (change)="onFileChange($event.target.files,'',badge)"/>
        <img [src]="badge.iconLink" alt="badgeImage" width="180px" height="60px">
        <button  type="button" class="btn btn-browse step-browse-btn mt-1"
            (click)="imageUploader.click()">{{ "Button.update_badge" | translate}}</button>
    </div>
</div>
</span>